import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import CodeMirror from '@uiw/react-codemirror';
import { javascript } from '@codemirror/lang-javascript';
import CheerioButton from '../../../Components/CheerioButton';
import colors from '../../../Utils/colors';

interface CodeNodeModalProps {
    data: {
        variableName?: string;
        codeSnippet?: string;
    };
    setData: (data: { variableName?: string; codeSnippet?: string }) => void;
}

const CodeNodeModal: React.FC<CodeNodeModalProps> = ({ data, setData }) => {
    const [variableName, setVariableName] = useState<string>(data?.variableName || '');
    const [codeSnippet, setCodeSnippet] = useState<string>(data?.codeSnippet || '');
    const [testResult, setTestResult] = useState<string | number | boolean | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        setData({ variableName, codeSnippet });
    }, [variableName, codeSnippet]);

    // Function to test code snippet
    const runTestCode = () => {
        setError(null);
        setTestResult(null);
        try {
            // Wrap snippet in IIFE to allow multiple statements
            const result = Function('"use strict"; return (' + codeSnippet + ')')();
            setTestResult(result);
        } catch (err: any) {
            setError(err.message || 'Error executing code');
        }
    };

    return (
        <div className="w-100 h-100 py-3 d-flex flex-column justify-content-start align-items-start">
            <h4 style={{ marginBottom: '10px', fontWeight: 600 }}>JS Code Snippet</h4>
            <div style={{ width: '100%', marginBottom: 16 }}>
                <CodeMirror
                    value={codeSnippet}
                    height="200px"
                    extensions={[javascript({ jsx: false })]}
                    onChange={(value) => setCodeSnippet(value)}
                    basicSetup={{
                        lineNumbers: true,
                        highlightActiveLineGutter: true,
                        highlightActiveLine: true,
                        foldGutter: true,
                        tabSize: 2,
                        highlightSelectionMatches: true,
                    }}
                />
            </div>
            <CheerioButton
                borderStyle={{ width: '45%' }}
                textStyle={{
                    fontSize: 16,
                    padding: 0,
                    margin: 0,
                    fontWeight: 600,
                    color: colors.white,
                }}
                btnText="Test Code"
                onclick={runTestCode}
                backColor={colors.primary03}
                icon={undefined}
                id={undefined}
            />

            {error && <div style={{ color: 'red', marginBottom: 8 }}>Error: {error}</div>}
            {testResult !== null && (
                <div style={{ color: 'green', marginBottom: 8 }}>Output: {JSON.stringify(testResult)}</div>
            )}

            <h4 style={{ marginBottom: '10px', fontWeight: 600, marginTop: 16 }}>Save reply in a variable</h4>
            <TextField
                fullWidth
                size="small"
                placeholder="Enter variable name"
                value={variableName}
                onChange={(e) => setVariableName(e.target.value)}
                style={{ marginBottom: '15px' }}
            />
        </div>
    );
};

export default CodeNodeModal;
